<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CardTag } from '../CardTag';
	import { TagCross } from '../CardTag/TagCross';
	import { TagText } from '../CardTag/TagText';
	import { NewsMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { getTagLink } from '#lib/features/news/utils/getTagLink/getTagLink.js';
	import { getSearchVariables } from '#lib/websites/news/pages/NewsHomePage/utils/getSearchVariables/getSearchVariables.js';
	import { isArtistActive } from '#lib/websites/news/pages/NewsHomePage/utils/isArtistActive/isArtistActive.js';
	import { page } from '$app/state';
	import { track } from '$global/utils/track';

	let {
		dataCy,
		name,
		onClickCross = undefined,
		onClick = undefined,
		showNewVersion,
		showCross,
		href,
		forceShowGlobalNav = undefined,
		...rest
	}: Props = $props();

	interface Props {
		href?: string | null;
		class?: string;
		dataCy: string;
		name: string;
		showCross?: boolean;
		onClickCross?: (() => void) | undefined;
		onClick?: (() => void) | undefined;
		showNewVersion: boolean;
		forceShowGlobalNav?: boolean | undefined;
	}

	// The URL param is the fallback authority: on error pages (and any route
	// whose load doesn't provide showGlobalNav) page.data is empty, and
	// app-mode (global_nav=0) visitors must stay on navless links.
	let showGlobalNav = $derived(
		forceShowGlobalNav ??
			page.data.showGlobalNav ??
			page.url.searchParams.get('global_nav') !== '0'
	);
	let searchParams = $derived(page.url.searchParams);
	let variables = $derived(getSearchVariables(searchParams));

	let getIsArtistActive = $derived((searchArtist: string) =>
		isArtistActive({
			searchArtist,
			variables,
		})
	);
</script>

{#if name}
	<CardTag
		{showNewVersion}
		onclick={() => {
			if (onClick) {
				onClick();
			}

			track(NewsMixpanelEvents.Search, { artist: name });
		}}
		dataCy={`${dataCy}`}
		href={href !== undefined
			? (href as string)
			: getTagLink(showGlobalNav, 'artist', name)}
		class={twMerge(
			classNames(
				'h-[20px] border-red-600',
				getIsArtistActive(name) ? 'bg-red-600' : 'bg-transparent'
			),
			rest.class
		)}
	>
		<TagText
			color="red"
			isActive={getIsArtistActive(name)}
			label={name}
			class={showCross ? 'pr-6 font-semibold' : 'font-semibold'}
		/>
		{#if showCross}
			<TagCross
				color={getIsArtistActive(name) ? 'gray-0' : 'red-600'}
				onclick={(e: Event) => {
					if (onClickCross) {
						e.preventDefault();
						e.stopPropagation();
						onClickCross();
					}
				}}
			/>
		{/if}
	</CardTag>
{/if}
